import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Select, Card, Image, Spin, message } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { Row, Col } from 'react-bootstrap';
import { setBoxCount, setAlaCarteStep, setBoxProduct } from './store/actionCreators';
import { getAlaCarteBoxProduct } from '../../data/API';
import Box from '../../assets/images/boxfinal.png';
import '../StorageBox/BuyingBox/StorageDetail/index.css';

const BoxSelection = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { boxCount, currentStep, boxProduct } = useSelector(state => state.alaCarte);
  const { isParentNextStepClicked, setParentNextStepClicked, tabref } = props;

  useEffect(() => {
    const fetchBoxProduct = async () => {
      try {
        setLoading(true);
        const response = await getAlaCarteBoxProduct();
        console.log('Box product API response:', response);

        if (response?.data?.results && response.data.results.length > 0) {
          const product = response.data.results.find(p =>
            p.title?.toLowerCase().includes('individual') ||
            p.subtitle?.toLowerCase().includes('à la carte') ||
            p.total_boxes === 1
          ) || response.data.results[0];
          console.log('Box product loaded:', product);
          dispatch(setBoxProduct(product));
        } else {
          console.error('No results in response:', response?.data);
          message.error('Individual Box product not found. Please contact support.');
        }
      } catch (error) {
        console.error('Error fetching box product:', error);
        console.error('Error details:', error.response?.data);
        message.error(`Failed to load box information: ${error.response?.data?.detail || error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchBoxProduct();
  }, [dispatch]);

  useEffect(() => {
    if (boxCount >= 0) {
      form.setFieldsValue({ boxCount });
    }
  }, [boxCount, form]);

  useEffect(() => {
    if (tabref?.current) {
      window.scrollTo({
        top: tabref.current.offsetTop - 100,
        behavior: 'smooth'
      });
    }
  }, [tabref]);

  useEffect(() => {
    if (isParentNextStepClicked) {
      setParentNextStepClicked(false);
      handleNext();
    }
  }, [isParentNextStepClicked]);

  const handleNext = async () => {
    try {
      const values = await form.validateFields();
      dispatch(setBoxCount(values.boxCount || 0));
    } catch (error) {
      message.error('Please complete the form before proceeding');
      console.error('Validation failed:', error);
    }
  };

  const onBoxSelected = async (value) => {
    console.log('Box count selected:', value);
    dispatch(setBoxCount(value));
    form.setFieldsValue({ boxCount: value });
  };

  return (
    <div>
      <div className="steps bg-white" id="steps">
        <h2 className="shopping-cart-header text-white text-center py-2 fs-20 steps-title">
          Step 1: Select Boxes
        </h2>
        <Card bordered={false} className="w-100 px-3 pt-3 pb-4">
          <Spin spinning={loading} tip="Loading box information...">
            <Form
              form={form}
              layout="vertical"
              autoComplete="off"
              initialValues={{ boxCount: boxCount || 0 }}
              style={{ position: 'relative', zIndex: 0 }}>
              <Row className="py-4">
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="boxCount"
                    label="How many boxes do you need?"
                    rules={[
                      {
                        required: false,
                        validator: (_, value) => {
                          if (value > 14) {
                            return Promise.reject('Maximum 14 boxes for à la carte orders');
                          }
                          return Promise.resolve();
                        }
                      }
                    ]}>
                    <Select size="large" placeholder="Select a box count" onChange={onBoxSelected}>
                      <Select.Option value={0}>------</Select.Option>
                      {Array.from({ length: 14 }, (_, i) => i + 1).map(num => (
                        <Select.Option key={num} value={num}>
                          {num} {num === 1 ? 'box' : 'boxes'}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  {boxProduct && (
                    <div className="storage-box-content">
                      <div className="d-flex justify-content-start align-items-center pb-2">
                        <div className="storage-box-image pr-4">
                          <Image src={boxProduct.image || Box} preview={false} alt={boxProduct.title} />
                        </div>
                        <div className="storage-box-desc s-color-black">
                          <div dangerouslySetInnerHTML={{ __html: boxProduct.description }} />
                        </div>
                      </div>
                      <div className="s-content-divider"></div>
                    </div>
                  )}
                </Col>
              </Row>
            </Form>
          </Spin>
        </Card>
      </div>
    </div>
  );
};

BoxSelection.propTypes = {
  isParentNextStepClicked: PropTypes.bool,
  setParentNextStepClicked: PropTypes.func,
  tabref: PropTypes.object,
};

export default BoxSelection;
